import { defineComponent as _defineComponent } from 'vue'
import {computed, PropType} from "vue";

  import OrderWorklogsListDate from "./OrderWorklogsListDate.vue";
  import {OrderWorklogsDate, OrderWorklogsDateEmployee} from "@/model/OrderWorklogs";
  import router from "@/router";
  import moment from "moment";
  import {WorklogType} from "@/enums";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderWorklogsList',
  props: {
    items: {
      type: Array as PropType<Array<OrderWorklogsDate>>,
      default: () => new Array<OrderWorklogsDate>()
    }
  },
  setup(__props) {

const props = __props

  

  const date = computed(() => {
    return router.app.$route.query.date as string;
  });

  const isDay = computed(() => {
    return moment(date.value, "YYYY-MM-DD", true).isValid();
  });

  const dayItems = computed(() => {
    const found = props.items.find(dateEntry => dateEntry.date === date.value);
    return found ? found.employees : new Array<OrderWorklogsDateEmployee>();
  });

  function selectDate(date: string) {
    router.push({query: Object.assign({}, router.app.$route.query, {date: date})});
  }

  function getMinutes(item: OrderWorklogsDate, worklogType: WorklogType | string): number {
    let minutes = item.minutes
      .find(entry => entry.worklogType === worklogType);
    return minutes ? minutes.minutes : 0;
  }

return { __sfc: true,props, date, isDay, dayItems, selectDate, getMinutes, OrderWorklogsListDate }
}

})